import script from "./ScriptHistoryByScript.vue?vue&type=script&setup=true&lang=js"
export * from "./ScriptHistoryByScript.vue?vue&type=script&setup=true&lang=js"

import "./ScriptHistoryByScript.vue?vue&type=style&index=0&id=5ab1d387&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ab1d387"]])

export default __exports__